module.exports = __webpack_public_path__ + "img/settings_black_24dp.5caa9717.svg";